import React from 'react'
import PropTypes from 'prop-types'

import './ProgressBar.scss'

const ProgressBar = ({ progress = 0 }) => (
  <div className='fi_progress'>
    <div className='fi_progress__bar' style={{ transform: `scaleX(${progress})`, opacity: (progress > 1 ? 0 : 1) }} />
  </div>
)

ProgressBar.propTypes = {
  progress: PropTypes.number
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/ProgressBar.js